export function contarOrientacoes(demanda?: any | null, usuario?: { profile?: string; id?: string | number } | null): number {
    if (!demanda) {
        return 0;
    }

    let total = 0;

    const orientacoes = demanda.orientacoes;

    if (Array.isArray(orientacoes)) {
        const possuiOrientacaoPrevia = orientacoes.some((item) => typeof item === "string" && item.trim().length > 0);
        const possuiOrientacaoCompleta = orientacoes.some((item) => item !== null && typeof item === "object");

        if (possuiOrientacaoPrevia) {
            total += 1;
            console.log('[contarOrientacoes] ✅ Orientação Prévia encontrada. Total:', total);
        }

        if (possuiOrientacaoCompleta) {
            total += 1;
            console.log('[contarOrientacoes] ✅ Orientação Completa encontrada. Total:', total);
        }
    }

    const podeVerRecusasProfissionais = usuario?.profile === 'admin' || usuario?.profile === 'operador';
    if (podeVerRecusasProfissionais && demanda.recusas_profissionais && demanda.recusas_profissionais.length > 0) {
        total += 1;
        console.log('[contarOrientacoes] ✅ Recusas Profissionais encontradas. Quantidade:', demanda.recusas_profissionais.length, 'Total:', total);
    }

    const podeVerInterrupcao = usuario?.profile === 'admin' || usuario?.profile === 'operador';
    if (podeVerInterrupcao && demanda.interrupcoes_profissionais && Array.isArray(demanda.interrupcoes_profissionais) && demanda.interrupcoes_profissionais.length > 0) {
        total += 1;
        console.log('[contarOrientacoes] ✅ Interrupções Profissionais encontradas. Quantidade:', demanda.interrupcoes_profissionais.length, 'Total:', total);
    } else {
        console.log('[contarOrientacoes] ❌ Interrupções Profissionais:', {
            existe: !!demanda.interrupcoes_profissionais,
            isArray: Array.isArray(demanda.interrupcoes_profissionais),
            length: demanda.interrupcoes_profissionais?.length || 0,
            podeVer: podeVerInterrupcao
        });
    }

    const podeVerConclusao = usuario?.profile === 'admin' || 
                             usuario?.profile === 'operador' || 
                             (usuario?.profile === 'comum' && Number(usuario?.id) === demanda?.id_usuario);
    const temDataConclusao = typeof demanda.data_conclusao === 'string' && demanda.data_conclusao.trim().length > 0;
    const statusNormalizadoConclusao = demanda.status?.trim().toLowerCase();
    const statusValidosConclusao = ["em conferência", "finalizada", "cancelada"];
    const temHistoricoConclusao = demanda?.historico?.some((h: any) => 
        h.acao?.toLowerCase().includes('concluiu demanda')
    );
    const demandaConcluida = temDataConclusao || 
                             (statusValidosConclusao.some(status => statusNormalizadoConclusao === status) && !!demanda?.info_conclusao) || 
                             (temHistoricoConclusao && !!demanda?.info_conclusao);
    if (podeVerConclusao && demandaConcluida) {
        total += 1;
        console.log('[contarOrientacoes] ✅ Conclusão encontrada. Total:', total);
    }

    const podeVerCancelamento = usuario?.profile !== 'comum' && usuario?.profile !== 'Solicitante';
    const statusNormalizado = demanda.status?.trim().toLowerCase();
    if (podeVerCancelamento && (statusNormalizado === "cancelada" || statusNormalizado === "cancelado")) {
        total += 1;
        console.log('[contarOrientacoes] ✅ Status Cancelada encontrado. Status:', demanda.status, 'Total:', total);
    }

    const podeVerFinalizacao = usuario?.profile === 'admin' || usuario?.profile === 'operador';
    const statusFinalizado = demanda.status?.trim().toLowerCase() === "finalizada";
    const temInfoFinalizacao = typeof demanda.info_finalizacao === 'string' && demanda.info_finalizacao.trim().length > 0;
    const temHistoricoFinalizacao = demanda?.historico?.some((h: any) => {
        const acaoLower = h.acao?.toLowerCase() || '';
        return acaoLower.includes('demanda finalizada') || 
               acaoLower.includes('finalizou demanda com aceite') ||
               acaoLower.includes('finalizou demanda com recusa');
    });
    if (podeVerFinalizacao && statusFinalizado && (temInfoFinalizacao || temHistoricoFinalizacao)) {
        total += 1;
        console.log('[contarOrientacoes] ✅ Finalização encontrada. Total:', total);
    }

    console.log('[contarOrientacoes] 📊 Total final:', total);
    return total;
}

